import * as THREE from 'three'
import { GLTF, GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

import World from '../World'
import Experience from '..'

import SmoothTransition from './SmoothTransition'
import TextureBuilder from './TextureBuilder'

import TextureBuilderDefault from './TextureBuilderDefault'

import LoadingManager from '../Utils/LoadingManager'

import modelSrc from '../../assets/model/shark/Shark_Animated.glb'

import SamplerMaterial from './shaders/sample-shader/material'
import SamplerMaterialDefault from './shaders/sample-shader-default/material'

import ImageTracker from './ImageTracker'

export default class Shark {
  static instance: Shark


  public imageTracker: ImageTracker
  public textureBuilder!: TextureBuilder
  public textureBuilderDefault!: TextureBuilderDefault
  private smoothTransition!: SmoothTransition

  public experience = new Experience()
  public world = new World()

  public isScreenRelative = false

  private action!: THREE.AnimationAction
  private mixer!: THREE.AnimationMixer

  private isDefault = true;

  public model!: GLTF
  public group = new THREE.Group()
  
  public ModelGroup = new THREE.Group()

  // Move around X,Y
  private raycaster = new THREE.Raycaster()
  private clickMouse = new THREE.Vector2()
  private moveMouse = new THREE.Vector2()
  private draggable!: any

  private isTouch = false
  private isFree = false



  // Rotate <<|>> Scale update
  private cameraQinvert = new THREE.Quaternion()
  private cameraWorldPos = new THREE.Vector3()
  private centerOfScene = new THREE.Vector3(0, 0, 0)

  // Initial shark values to reset the scale/pos and rotation
  private sharkQ = new THREE.Quaternion()
  private sharkP = new THREE.Vector3()
  private sharkS = new THREE.Vector3()

  constructor() {

    this.imageTracker = new ImageTracker(this)
    this.textureBuilder = new TextureBuilder(this)
    this.textureBuilderDefault = new TextureBuilderDefault(this)
    this.smoothTransition = new SmoothTransition(this)

    this.getQueryString();
    //this.load()
    this.setListeners()
  }

  private setListeners() {
    window.addEventListener('touchstart', (event) => {
      if (this.experience.navigationManager.step > 0) {
        if (this.draggable) {
          this.draggable = null
          return
        }

        const { clientX, clientY } = event.touches[0]

        this.clickMouse.x = (clientX / window.innerWidth) * 2 - 1
        this.clickMouse.y = -(clientY / window.innerHeight) * 2 + 1

        const found = this.intersect(this.clickMouse)

        if (found.length > 0 && found[0].object.userData.draggable) {
          this.draggable = found[0].object
        }
      }
    })

    document.addEventListener(
      'touchmove',
      (event) => {
        if (this.experience.navigationManager.step > 0) {
          if (event.touches.length >= 1) {
            this.isTouch = true

            const { clientX, clientY } = event.touches[0]

            this.moveMouse.x = (clientX / window.innerWidth) * 2 - 1
            this.moveMouse.y = -(clientY / window.innerHeight) * 2 + 1
          }
        }
      },
      false
    )

    document.addEventListener(
      'touchend',
      (_) => {
        if (this.experience.navigationManager.step > 0) {
          this.isTouch = false
        }
      },
      false
    )
  }

  private intersect(pos: THREE.Vector2) {
    this.raycaster.setFromCamera(pos, this.experience.camera.zapparCamera)
    return this.raycaster.intersectObjects(this.experience.scene.children, true)
  }

  private updateGUI() {
    const cameraBtn = document.getElementById('camera-btn') as HTMLImageElement
    const handPrompt = document.getElementById(
      'hand-prompt'
    ) as HTMLImageElement

    const isHidden = this.experience.navigationManager.step === 0

    if (cameraBtn && handPrompt && isHidden) {
      cameraBtn.style.display = 'block'
      cameraBtn.style.opacity = '1'

      handPrompt.style.display = 'block'
      handPrompt.style.opacity = '1'
    }
  }

  public getQueryString(){
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    // let country = urlParams.get('country')
    // let code = urlParams.get('code')
    const id = urlParams.get('id')
    let country = '';
    let code = '';
    let targetZptSrc;


    //check zpt exists
    if(id != null){
      country = id.replace(/[0-9]/g, '');
      code = id.replace(/[A-Z]/g, '');
      targetZptSrc = 'https://ddg67ecygv8rc.cloudfront.net/Crayola/NewTargets/' + country + '/target' + code + '.zpt';
      //alert('id: ' + id + ', country: ' + country + ', code: ' + code);
   
      fetch(targetZptSrc , { method: 'HEAD' })
          .then(res => {
              if (res.ok) {
      
                  //alert('Using zpt ID: ' + id);
                  this.isDefault = false;
                  this.imageTracker.setTracker(false, country, code);
              } 
              else {
       
                  //alert("zpt does not exist \r\nPlease add correct query string to end of URL \r\ne.g('/?id=GB1') \r\noptions are : GB 1-12, BKP 1, TW 1-4, PT 1-8, GR 1-3, IT 1 or 7, CZHU 1-8, ADR 1-4 & DACH 1-5 or 8-16")    
                  //alert("zpt does not exist, using default target");
                  this.imageTracker.setTracker(true, country, code);
                  
                }
          }).catch(err => console.log('Error:', err));
        }
      else{
        //alert("Using default target");
        this.imageTracker.setTracker(true, country, code);
        
      }
    this.load();

  }


  public start() {
    const handler = (visible: boolean) => {
      if (visible && !this.model.scene.visible) {
        this.model.scene.visible = visible
        //here
        this.action?.play()
        // this.updateGUI()cd
      }
      
      if (!visible && !this.isScreenRelative) {
        // this.textureBuilder.updateCopyPass = false
        this.imageTracker.imageTracker.enabled = false

        if(this.isDefault){
          this.updateDefaultMaterial(this.textureBuilderDefault.samplerMaterialBackup)
        }
        else{
          this.updateMaterial(this.textureBuilder.samplerMaterialBackup)
        }

        this.imageTracker.imageTrackerGroup.remove(this.model.scene)

        this.model.scene.position.z = -9
        this.experience.scene.add(this.model.scene)

        this.smoothTransition.center(this.isDefault)
      }
    }

    this.experience.eventEmitter.on('sharkSeenEvent', handler)
  }

  private getSharkMesh() {
    const mesh = this.model.scene.children.find(
      (c) => c.name === 'ParentFBXASC032Sharkbody1'
    ) as THREE.SkinnedMesh

    return mesh
  }

  public updateMaterial(mat: SamplerMaterial | null) {
    if (this.model?.scene && mat) {
      const mesh = this.getSharkMesh()

      mesh.material = mat
      mesh.material.needsUpdate = true
    }
  }


  public updateDefaultMaterial(mat: SamplerMaterialDefault | null) {
    if (this.model?.scene && mat) {
      const mesh = this.getSharkMesh()

      mesh.material = mat
      mesh.material.needsUpdate = true
    }
  }

  private load() {
    const gltfLoader = new GLTFLoader(LoadingManager)

    gltfLoader.load(
      modelSrc,
      (gltf) => {
        this.model = gltf

        const mesh = this.getSharkMesh()
        mesh.userData = { name: 'SHARK', draggable: true }

        this.mixer = new THREE.AnimationMixer(this.model.scene)
        this.action = this.mixer.clipAction(this.model.animations[0])
      
        if(this.isDefault){
          this.model.scene.scale.setScalar(0.007);
        }
        else {
          this.model.scene.scale.setScalar(0.00237);
        }

        const box = new THREE.Box3().setFromObject(this.model.scene)
        const center = new THREE.Vector3()
        box.getCenter(center)
        this.model.scene.position.sub(center)
        
        if(this.isDefault){  
          this.model.scene.rotation.y = -Math.PI / 2
          this.model.scene.position.y = -0.6
          this.model.scene.position.x = 0.55
          this.model.scene.visible = false
        }
        else{
          this.ModelGroup.rotation.z = 0.05;
          this.model.scene.rotation.y = -Math.PI/2;
          this.model.scene.position.x = 0.145;
          this.model.scene.position.y = -0.865;
          this.model.scene.position.z = -0.1;
        }       

        this.model.scene.visible = false

        // Clone
        this.sharkP.copy(this.model.scene.position)
        this.sharkS.copy(this.model.scene.scale)
        this.sharkQ.copy(this.model.scene.quaternion)

        // this.cloneModel = this.model.scene.clone()
        this.ModelGroup.add(this.model.scene)
       
        this.imageTracker.imageTrackerGroup.add(this.ModelGroup)

        this.start()
      },
      undefined,
      () => {
        console.log('An error ocurred loading the GLTF model')
      }
    )
  }

  public reset() {
    if (this.model) {
      // Stop all animations running if any
      //here
      this.smoothTransition.removeAll()

      // Reset options
      this.isFree = false
      this.isTouch = false
      this.isScreenRelative = false

      // Reset camera positions
      this.cameraQinvert = new THREE.Quaternion()
      this.cameraWorldPos = new THREE.Vector3()
      this.centerOfScene = new THREE.Vector3(0, 0, 0)
      this.experience.camera.controlsEnabled(false)
      this.experience.camera.resetPerspectiveCamQuaternion()

      this.experience.scene.remove(this.model.scene)

      this.model.scene.position.copy(this.sharkP)
      this.model.scene.scale.copy(this.sharkS)
      this.model.scene.quaternion.copy(this.sharkQ)

      // Reset visibility by default not visible
      this.model.scene.visible = false

      // Reset image tracker
      this.imageTracker.imageTracker.enabled = true
      this.imageTracker.clear()
      this.imageTracker.imageTrackerGroup.add(this.model.scene)
    }
  }

  private setScreenRelative() {
    if (!this.isScreenRelative) {
      this.imageTracker.imageTracker.enabled = false
      this.imageTracker.imageTrackerGroup.remove(this.model.scene)

      this.experience.scene.add(this.model.scene)

      const box = new THREE.Box3().setFromObject(this.model.scene)
      const center = box.getCenter(new THREE.Vector3())

      const position = {
        x: this.model.scene.position.x - center.x + 0.4,
        y: this.model.scene.position.y - center.y,
        z: this.model.scene.position.z - center.z  ,
      }
      const rotation = {
        y: -0.628,
        x: 0.314,
      }

    
      this.model.scene.position.x = position.x
      this.model.scene.position.y = position.y
      this.model.scene.position.z = position.z

      this.model.scene.rotation.x = rotation.x
      this.model.scene.rotation.y = rotation.y

  


      this.isScreenRelative = true
    }
  }

  public free() {
    if (this.model) {
      this.imageTracker.imageTracker.enabled = false
      this.imageTracker.clear() // clear tracking values
      this.smoothTransition.removeAll() // Stop running all transitions
      //here
      this.setScreenRelative() // Center shark relative to screen if not been done before

      this.model.scene.visible = false

      setTimeout(() => {
        this.model.scene.visible = true

        const box = new THREE.Box3().setFromObject(this.model.scene)
        const center = new THREE.Vector3()
        box.getCenter(center)
        this.model.scene.position.sub(center)

        this.smoothTransition.zoomIn(this.model)

        this.experience.camera.controlsEnabled()

        this.isFree = true
      }, 200)
    }
  }

  private dragShark() {
    if (this.experience.navigationManager.step > 0) {
      if (this.draggable && this.model && this.isTouch) {
        this.model.scene.position.x = this.moveMouse.x * 5
        this.model.scene.position.y = this.moveMouse.y * 5
      }
    }
  }

  public update() {
    this.mixer?.update(this.experience.clock.getDelta())

    this.smoothTransition?.update()
    this.imageTracker?.update()

    /**
     * Control shark gestures and positions update
     */
    if (this.isFree) {
      const { perspectiveCamera } = this.experience.camera

      this.cameraQinvert.copy(perspectiveCamera.quaternion)
      this.cameraQinvert.invert()

      perspectiveCamera.getWorldPosition(this.cameraWorldPos)

      this.dragShark()

      const distance = this.cameraWorldPos.distanceTo(this.centerOfScene)
      this.model.scene.scale.setScalar(distance)

      this.model.scene.quaternion.copy(this.cameraQinvert)
    }
  }
}
